module.exports = __webpack_public_path__ + "static/media/item01.fbabd199.png";